module.exports = __webpack_public_path__ + "img/pc_banner_support.933a9d2c.jpeg";